import { dayProgress } from "./time.js";
import createLogotype from "../logotype.js";

export function getInitialKansasWallpaperProgress() {
	const kansasTime = new Date(
		new Date().toLocaleString("en-US", {
			timeZone: "America/Chicago"
		})
	);

	return parseFloat(dayProgress(kansasTime).toFixed(3));
}

function currentKansasWallpaperProgress() {
	const kansasTime = new Date(
		new Date().toLocaleString("en-US", {
			timeZone: "America/Chicago"
		})
	);

	return parseFloat(dayProgress(kansasTime).toFixed(3));
}

export function mountLandingWallpaper(canvas) {
	let progress = getInitialKansasWallpaperProgress();
	let rafId;

	function step() {
		const next = currentKansasWallpaperProgress();

		if (next - progress > 0.25) {
			progress = next;
		} else if (progress < next) {
			progress += 0.001;
		} else {
			progress = next;
		}

		createLogotype(canvas, progress);
		rafId = requestAnimationFrame(step);
	}

	createLogotype(canvas, progress);
	rafId = requestAnimationFrame(step);

	return function unmountLandingWallpaper() {
		if (rafId !== undefined) {
			cancelAnimationFrame(rafId);
		}
	};
}
